import { render, staticRenderFns } from "./BikeParameters.vue?vue&type=template&id=625b1516&scoped=true&"
import script from "./BikeParameters.vue?vue&type=script&lang=js&"
export * from "./BikeParameters.vue?vue&type=script&lang=js&"
import style0 from "./BikeParameters.vue?vue&type=style&index=0&id=625b1516&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625b1516",
  null
  
)

export default component.exports